/**
* Version 0.100
* 
* Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
* Copyright 2016 - 2025.
* 
* !Changelog

* 	17-10-2018
* 	- [BORN] This class is born. Hooray!
* 
* !Usage
* 
*   - 
* 	
* !Wishlist
* 
* 	// none
* 	
*/

var specific_spotlight = {};

(function () {

	// DOCUMENT READY  *****************************************************************
	// DOCUMENT READY *****************************************************************
	// DOCUMENT READY ******************************************************************
	// DOCUMENT READY ******************************************************************

	this.onready = function (

	) {

		/**
		 * Spotlight init
		 */
		var spotlightSlides = $('.js-spotlight-slide');
		var i = 0;
		var interval;

		// Clear existing interval if it exists
		if (interval) {
			clearInterval(interval);
		}

		interval = setInterval(function () {
			spotlightSlides.removeClass('active');
			i = (i + 1) % spotlightSlides.length;
			spotlightSlides.eq(i).addClass('active');
		}, 2000);

	};

	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************
	// METHODS *****************************************************************

	// none yet

}).apply(specific_spotlight);